export type FeelPref = 'auto' | 'on' | 'off';

export interface UiPrefs {
  tooltipsEnabled: boolean;
  screenShake?: FeelPref;
  haptics?: FeelPref;
}

export const PREFS_KEY = 'casino.prefs.v1';

const DEFAULTS: UiPrefs = { tooltipsEnabled: true };

const FEEL_VALUES = new Set<FeelPref>(['auto', 'on', 'off']);

function isFeelPref(v: unknown): v is FeelPref {
  return typeof v === 'string' && FEEL_VALUES.has(v as FeelPref);
}

export function loadPrefs(): UiPrefs {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(PREFS_KEY);
  } catch {
    return { ...DEFAULTS };
  }
  if (raw === null) return { ...DEFAULTS };
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (parsed === null || typeof parsed !== 'object') return { ...DEFAULTS };
    const obj = parsed as Record<string, unknown>;
    if (typeof obj.tooltipsEnabled !== 'boolean') return { ...DEFAULTS };
    const out: UiPrefs = { tooltipsEnabled: obj.tooltipsEnabled };
    if (obj.screenShake !== undefined) {
      if (!isFeelPref(obj.screenShake)) return { ...DEFAULTS };
      out.screenShake = obj.screenShake;
    }
    if (obj.haptics !== undefined) {
      if (!isFeelPref(obj.haptics)) {
        // Drop the invalid haptics field but keep validated screenShake.
        return out;
      }
      out.haptics = obj.haptics;
    }
    return out;
  } catch {
    return { ...DEFAULTS };
  }
}

export function savePrefs(prefs: UiPrefs): void {
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  } catch {
    // Safari private mode, quota exceeded — swallow; prefs aren't load-bearing.
  }
}
